// extracted by mini-css-extract-plugin
module.exports = {"compass":"styles_compass__zyeYP","rightArrow":"styles_rightArrow__3s4EF","leftArrow":"styles_leftArrow__1YnzJ"};